import { render, staticRenderFns } from "./SurveyDescriptionField.vue?vue&type=template&id=3dbcbdf3&scoped=true&"
import script from "./SurveyDescriptionField.vue?vue&type=script&lang=js&"
export * from "./SurveyDescriptionField.vue?vue&type=script&lang=js&"
import style0 from "./SurveyDescriptionField.vue?vue&type=style&index=0&id=3dbcbdf3&lang=scss&scoped=true&"
import style1 from "./SurveyDescriptionField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbcbdf3",
  null
  
)

export default component.exports